import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { InferGetServerSidePropsType } from 'next';
import { SSRConfig } from 'next-i18next';

import { wrapper } from '@store/store';

import CMSPage from '@routes/CMSPage';

import { slugRouteRedirectsHandler } from '@utils/redirects';
import { fetchCMSComponentsData } from '@utils/fetchCMSComponentsData';
import { getLocaleFromContext } from '@utils/getLocaleFromContext';
import { getRequestInstance } from '@utils/request';

import { cmsPage as cmsPageEndpoint } from '@common/endpoints';
import { CmsGenericPage } from '@common/types/cms';

const CMS = ({
  pageData,
}: InferGetServerSidePropsType<typeof getServerSideProps>) => (
  <CMSPage pageData={pageData} />
);

type ReturnProps = SSRConfig & { pageData: CmsGenericPage };

export const getServerSideProps = wrapper.getServerSideProps<ReturnProps>(
  store => async context => {
    const { params, locale, resolvedUrl: resourcePath } = context;
    const request = getRequestInstance(context);
    const slug = params?.slug as string[];
    let pageData: CmsGenericPage;

    try {
      const { data } = await request.get(cmsPageEndpoint(slug.join('/')));

      await fetchCMSComponentsData(store.dispatch, data);
      pageData = data;
    } catch {
      return slugRouteRedirectsHandler(slug, resourcePath, locale);
    }

    return {
      props: {
        ...(await serverSideTranslations(getLocaleFromContext(context))),
        pageData,
      },
    };
  },
);

export default CMS;
